export const ACTION_BASE = 'ACTION_BASE';
export const ACTION_INPUT = 'ACTION_INPUT';
export const ACTION_COMBO = 'ACTION_COMBO';

/**
 * Enum Action types.
 * @readonly
 * @name ACTION_TYPE
 * @enum {string}
 */
const ACTION_TYPE = {
  /** Action base */
  ACTION_BASE: 'ACTION_BASE',
  /** Action input */
  ACTION_INPUT: 'ACTION_INPUT',
  /** Action combo */
  ACTION_COMBO: 'ACTION_COMBO',
};

export default ACTION_TYPE;
